<div class="content" *ngIf="emailVerified">
    <div class="card m-5">

        <div class="card-body">
            <h4 class="card-title">Link Expired</h4>
            <div style="font-size: 20px;margin: 15px;line-height: 2;">Link Already Expired, Redirecting to Login
            </div>

        </div>
    </div>
</div>

<div class="content" *ngIf="signupVerified">
    <div class="card m-5">

        <div class="card-body">
            <h4 class="card-title">Congratulations</h4>
            <div style="font-size: 20px;margin: 15px;line-height: 2;">Account has been created successfully, Redirecting to Login
            </div>
        </div>
    </div>
</div>
<ng-template #progressDialog>
    <mat-dialog-content>
        <p style="font-size: 18px;">Logging you in please wait!</p>
    </mat-dialog-content>
    <mat-spinner [diameter]="30" [strokeWidth]="3" mode="indeterminate" style="margin: auto;"></mat-spinner>
    <!-- <mat-dialog-actions align="end">
      <button mat-button matDialogClose color="primary">Dismiss</button>
    </mat-dialog-actions> -->
</ng-template>